import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Btn from './Btn'
import Img from './Img'
import { BiMenuAltLeft } from 'react-icons/bi'
import { useScreenSize } from '../others/useScreenSize.hook'

interface NavBarProps {
    transparent?: boolean;
    absolutelyPositioned?: boolean;
    textColor?: string;
}

function NavBar({ transparent, absolutelyPositioned, textColor }: NavBarProps) {
    const { size } = useScreenSize();
    const [menuCollapsed, setMenuCollapsed] = useState<boolean>(true);
    // const [isLoggedIn, setIsLoggedIn] = useState<boolean>(true);

    return (
        <nav
            style={{
                transition: 'max-height 0.5s ease',
                background: transparent ? 'transparent' : 'black',
                color: textColor ?? (transparent ? 'black' : 'white'),
                ...(!absolutelyPositioned ? {} : {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                })
            }}
            className={`
                px-4 lg:px-10 xl:middle py-4 flex items-center justify-between relative w-full z-20
                ${(!size['2md']) ? 'backdrop-blur-lg flex-col gap-4 !items-start max-h-[45px] overflow-hidden' : ''}
                ${(!menuCollapsed) ? 'max-h-screen' : ''}
            `}
        >

            <div className={`
                navLinks 
                flex
                ${(size['2md']) ? 'gap-12' : ''}
                ${(!size['2md']) ? '!flex flex-col gap-4 !items-start' : ''}
                items-center  transition-all
              `}>
                <Img
                    src={textColor === 'white' ? '/Murwiza_white.svg' : (transparent ? '/Murwiza.svg' : '/Murwiza_white.svg')}
                    alt='Logo'
                    width={126}
                    height={20}
                    className={`${size['lg'] ? '' : 'h-4 w-28'}`}
                />
                <Link to={'/'} className="hoverable text-base active">Accomodations</Link>
                <Link to={'/restaurants'} className=" hoverable text-base">Restaurants</Link>
                <Link to={'/carrentals'} className=" hoverable text-base">Car Rentals</Link>
                <Link to={'/company/signup'} className=" hoverable text-base">Register Company</Link>
            </div>
            <div className={`
                actionButtons 
                ${(size['2md']) ? 'flex' : ''}
                ${(!size['2md']) ? '!flex gap-1 !items-start' : ''}
                items-center gap-2
              `}>
                <div>
                    <Btn noBorder noBgBlur className='px-4 py-1 lg:px-7 lg:py-3 rounded-full'>
                        Create account
                    </Btn>
                </div>
                <div>
                    <Btn noBgBlur className='px-4 py-1 lg:px-7 lg:py-3 rounded-full w-44' filled>
                        Login
                    </Btn>
                </div>
            </div>
            <BiMenuAltLeft
                className={`
                    absolute right-7 top-4
                    cursor-pointer hover:rotate-2 rounded hover:bg-slate-200 fill-darkblue scale-150 
                    ${size['2md'] ? 'scale-x-0 hidden' : ''}
                    ${!menuCollapsed ? 'bg-slate-200' : ''}
                `}
                onClick={() => setMenuCollapsed(!menuCollapsed)}
            />
        </nav>
    )
}

export default NavBar